import React from "react";
import { ConversationsBubbleType } from "../../../../libraries/types_interface/chats/ChatsTypes";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { Col, Row } from "react-bootstrap";
import { toLocalDate } from "../../../../service/date_service/date_service";
import { textCase } from "../../../../service/ui/UI";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import Center from "../../../../widget/common/ui/Center";
import { IconCircleFilledIcon } from "../../../../widget/common/ui/Icon";
import AppTheme from "../../../../service/app_config/AppTheme";
import { AlertConfirm } from "../../../../widget/common/ui/Alerts";
import { useDispatch } from "react-redux";
import { cancelChatARF } from "../../../../libraries/state_reducers/chats/ChatsReducer";

const ARFLabelTypes: Record<string, string> = {
  "1": AppTranslation.text("feedback"),
  "2": AppTranslation.text("appointment_no"),
  "3": AppTranslation.text("reservation_no"),
};

const BubbleARF: React.FC<ConversationsBubbleType> = ({
  formType,
  messageType,
  arfData,
}) => {
  const dispatch = useDispatch();

  const labelHtml = ({
    title = "",
    value = "",
  }: {
    title: string;
    value: string;
  }): JSX.Element => {
    return (
      <>
        <TextBlock
          fontName="book"
          fontSize="13_14"
          textColor="primary"
          className="pb-2"
        >
          {AppTranslation.text(title)}
        </TextBlock>
        <TextBlock fontName="bold" fontSize="14_15" textColor="black">
          {textCase(value)}
        </TextBlock>
      </>
    );
  };

  const handleCancel = () => {
    AlertConfirm({
      title:
        formType === "2"
          ? "cancel_appointment_confirm"
          : "cancel_reservation_confirm",
      onConfirm: async () => {
        dispatch(cancelChatARF({ groupId: arfData?.group_id! }));
      },
    });
  };

  return (
    <div className="bubble-arf">
      <TextBlock
        fontName="book"
        fontSize="14_15"
        textColor="black"
        className="pb-2"
      >
        {ARFLabelTypes[formType === "1" ? "1" : formType === "2" ? "2" : "3"]}{" "}
        {arfData?.request_no!}
      </TextBlock>
      <TextBlock
        fontName="bold"
        fontSize="16_17"
        textColor={
          messageType === "31" || messageType === "41"
            ? "primary"
            : messageType === "33" ||
              messageType === "43" ||
              messageType === "32" ||
              messageType === "42"
            ? "red"
            : "black"
        }
      >
        {AppTranslation.text(
          messageType === "30" || messageType === "40"
            ? "request_sent"
            : messageType === "31" || messageType === "41"
            ? "acceptance_received"
            : messageType === "32" || messageType === "42"
            ? "request_rejected"
            : messageType === "33" || messageType === "43"
            ? "request_cancelled"
            : "submitted"
        )}
      </TextBlock>
      <Row className="pt-4">
        <Col>
          {labelHtml({
            title: "date",
            value:
              arfData !== undefined
                ? toLocalDate(arfData?.date!, "dd MMM yy", true)
                : "",
          })}
        </Col>
        <Col>
          {labelHtml({
            title: "time",
            value:
              arfData !== undefined
                ? toLocalDate(
                    new Date(
                      `${
                        new Date().toISOString().split("T")[0]
                      } ${arfData?.time!}`
                    ),
                    "p",
                    true
                  )
                : "",
          })}
        </Col>
      </Row>

      <div className="pt-4">
        {labelHtml({
          title:
            formType === "1" ? "subject" : formType === "3" ? "seats" : "name",
          value:
            formType === "1"
              ? arfData?.subject!
              : formType === "3"
              ? arfData?.no_people!
              : arfData?.name!,
        })}
      </div>

      <div className="pt-4">
        {labelHtml({
          title: formType === "1" ? "message" : "special_request",
          value: arfData?.description!,
        })}
      </div>

      <div
        className={`${
          formType !== "1" && (messageType === "30" || messageType === "40")
            ? "py-4"
            : ""
        }`}
      >
        {(messageType === "32" || messageType === "42") &&
        UtilityHelper.isNotEmpty(arfData?.reason!) ? (
          labelHtml({ title: "reason", value: arfData?.reason! })
        ) : (
          <></>
        )}
      </div>

      {formType !== "1" && (messageType === "30" || messageType === "40") && (
        <Center>
          <div role="button" onClick={handleCancel}>
            <IconCircleFilledIcon
              size={45}
              name="cancel"
              color={AppTheme.white}
            />
            <TextBlock
              fontName="book"
              fontSize="13_14"
              textColor="black"
              className="pt-2"
              center={true}
            >
              {AppTranslation.text("cancel")}
            </TextBlock>
          </div>
        </Center>
      )}
    </div>
  );
};

export default BubbleARF;
